import { cn } from "@/lib/utils";

const EMOJIS = [
  "😀","😁","😂","🤣","😊","😍","😘","😎",
  "🤔","😅","😇","🙂","😉","😌","😋","😜",
  "🤗","🤩","🥳","😢","😭","😤","😠","😡",
  "👍","👎","👏","🙌","🙏","💪","🔥","🎉",
  "❤️","🧡","💛","💚","💙","💜","💯","⭐",
  "✅","❌","👀","😴","🤯","🥺","😬","🤝",
];

export function EmojiPicker({ onPick, className }) {
  return (
    <div className={cn("grid w-64 grid-cols-8 gap-0.5 rounded-xl border border-slate-200 bg-white p-2 shadow-lg", className)} data-testid="emoji-picker">
      {EMOJIS.map((e) => (
        <button key={e} type="button" onClick={() => onPick(e)} data-testid={`emoji-${e}`}
          className="rounded-md p-1 text-lg leading-none transition-transform hover:scale-125 hover:bg-slate-100">{e}</button>
      ))}
    </div>
  );
}

export const QUICK_REACTIONS = ["❤️", "😂", "😮", "😢", "😡", "👍"];
